import React from "react";

const AddFile = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="m23.5 2 7.5 8v22.413c0 .42-.157.825-.437 1.122-.28.298-.658.465-1.052.465H5.49a1.454 1.454 0 0 1-1.05-.468 1.655 1.655 0 0 1-.44-1.12V3.588C4 2.71 4.668 2 5.49 2H23.5ZM16 16.4h-4.5v3.2H16v4.8h3v-4.8h4.5v-3.2H19v-4.8h-3v4.8Z"
            fill={fill}
        />
    </svg>
);

export default AddFile;
